





































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import {Action} from "vuex-class";
import {TemplateMaskedValue} from '@/store/templates/types';

@Component({})
export default class MaskingTemplate extends Vue {
  @PropSync("template") templateObject!: TemplateMaskedValue;
  @Action("getSystemSettings") actionGetSystemSettings: any;

  maskedVariables: string[] = [];

  async created() {
    const res = await this.actionGetSystemSettings('MASKED_SYSTEM_VARIABLES');
    if (res) {
      const matches = res.match(/\$(\w+)/g);
      this.maskedVariables = matches ? matches.map((m: string) => m.slice(1)) : [];
    }
  }

  get variablesFromText(): string[] {
    const contentSources = [
      this.templateObject?.message,
      this.templateObject?.content,
      this.templateObject?.subject,
      this.templateObject?.title,
      this.templateObject?.vkMessage,
      this.templateObject?.okMessage
    ]
        .filter(Boolean) as string[];
    const all = new Set<string>();
    const sys = new Set<string>(this.maskedVariables);
    contentSources.forEach(txt => {
      const matches = txt.match(/\$(\w+)/g);
      matches?.forEach(m => {
        const name = m.slice(1);
        if (!sys.has(name)) all.add(name);
      });
    });
    // У Telegram OTP текста нет — маскируемая переменная задаётся полем шаблона.
    const otpVariable = this.templateObject?.otp_code_variable?.trim();
    if (otpVariable && !sys.has(otpVariable)) all.add(otpVariable);
    return Array.from(all);
  }

  get displayedVariables(): string[] {
    const fromText = new Set<string>(this.variablesFromText);
    const masked = Array.isArray(this.templateObject?.masked_variables)
        ? (this.templateObject.masked_variables as string[])
        : [];
    const system = new Set<string>(this.maskedVariables);
    masked.forEach(name => {
      if (!system.has(name)) fromText.add(name);
    });
    return Array.from(fromText);
  }

  @Watch('templateObject.use_masking', { deep: true, immediate: true })
  onUseMaskingChange(val: number) {
    if (val !== 2) return;
    if (!Array.isArray(this.templateObject.masked_variables)) {
      this.templateObject.masked_variables = [];
    }
  }
}
